export default class CallCenterUserLoginModel {
  id!: string;

  ramal!: string;

  password!: string;
}
